import { isEvented } from './evented';
import * as Obj from '@emav-util/obj';
var StatefulMixin = {
    state: {},
    setState: function setState(stateUpdates) {
        var _this = this;
        if (typeof stateUpdates === 'function') {
            stateUpdates = stateUpdates();
        }
        var changes;
        Obj.each(stateUpdates, function (value, key) {
            if (_this.state[key] !== value) {
                changes = changes || {};
                changes[key] = {
                    from: _this.state[key],
                    to: value
                };
            }
            _this.state[key] = value;
        });
        if (changes && isEvented(this)) {
            this.trigger({
                changes: changes,
                type: 'statechanged'
            });
        }
        return changes;
    }
};
function stateful(target, defaultState) {
    Obj.assign(target, StatefulMixin);
    target.state = Obj.assign({}, target.state, defaultState);
    if (typeof target.handleStateChanged === 'function' && isEvented(target)) {
        target.on('statechanged', target.handleStateChanged);
    }
    return target;
}
export default stateful;